<template>
  <base-input :rules="internalRules" :errors="errors">
    <div class="relative z-10">
      <label :class="['absolute -top-2 left-2 -mt-px inline-block px-1 z-10 bg-white text-xs font-normal', `text-${labelColor}`]" v-if="label">{{ label }}</label>
      <select
        :disabled="disabled"
        :class="[
          'form-select mt-1 block w-full pl-3 pr-10 py-2 text-light border-gray-200 focus:outline-none ring-0 rounded-md transition-all ease-in-out duration-100 font-light bg-white',
          `focus-within:ring-${focusColor} focus-within:border-${focusColor} border-${borderColor}`,
          modelValue === null ? `text-${placeholderColor}` : '',
          `sm:text-${size}`,
        ]"
        @input="$emit('update:modelValue', $event.target.value)"
        @blur="validate"
        :title="getSelectTitle()"
      >
        <option disabled v-if="placeholder" :value="null" :selected="modelValue === null">{{ placeholder }}</option>

        <optgroup v-for="(optgroup, index) in optgroups" :key="index" :label="optgroup.label">
          <option v-for="option in optgroup.options" :key="option[valueKey]" :value="option[valueKey]" :selected="option[valueKey] === modelValue" :title="option[labelKey]">
            {{ option[labelKey] }}
          </option>
        </optgroup>

        <option v-for="option in options" :key="option[valueKey]" :value="option[valueKey]" :selected="option[valueKey] === modelValue" :title="option[labelKey]">
          {{ option[labelKey] }}
        </option>
      </select>
    </div>
  </base-input>
</template>

<script>
import validatable from "@/mixins/validatable";
import BaseInput from "@/components/base/BaseInput";

export default {
  mixins: [validatable],
  components: {
    BaseInput,
  },
  emits: ["update:modelValue"],
  props: {
    modelValue: {
      type: [Number, String],
      default: null,
    },
    label: String,
    placeholder: String,
    options: Array,
    optgroups: Array,
    valueKey: {
      type: String,
      default: "value",
    },
    labelKey: {
      type: String,
      default: "label",
    },
    size: {
      type: String,
      default: "sm",
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    focusColor() {
      return this.hasError ? "red-500" : "primary-500";
    },
    borderColor() {
      return this.hasError ? "red-500" : "gray-200";
    },
    labelColor() {
      return this.hasError ? "red-500" : "gray-900";
    },
    placeholderColor() {
      return this.hasError ? "red-400" : "gray-500";
    },
  },
  methods: {
    reset() {
      this.isResetting = true;
      this.$emit("update:modelValue", null);
    },

    getSelectTitle() {
      if (this.modelValue === null) return this.placeholder || "";

      // 1. Check options without groups
      const selectedOption = this.options ? this.options.find((o) => o[this.valueKey] === this.modelValue) : null;
      if (selectedOption) {
        return selectedOption[this.labelKey];
      }

      // 2. Check options within groups
      if (this.optgroups) {
        for (const group of this.optgroups) {
          const selectedInGroup = group.options.find((o) => o[this.valueKey] === this.modelValue);
          if (selectedInGroup) {
            return selectedInGroup[this.labelKey];
          }
        }
      }
      return "";
    },
  },
};
</script>
